import {
    IS_LOADING,
    SET_GENERAL_DATA,
    TOGGLE_NAV_DRAWER,
    SHOW_APP_BAR,
    SET_REGISTRATION_DATA,
    SHOW_ALERT_DIALOG,
    SHOW_CONFIRM_DIALOG,
    SET_CONFIRM_DIALOG_DATA,
    SET_ALERT_DIALOG_CONTENT,
    SET_BANK_LIST,
    GET_ANNOUNCEMENTS,
    GET_QUIZ,
    CREATE_QUIZ,
    UPDATE_QUIZ,
    GET_NOTE,
    GET_TIMETABLE
} from "../types";
import api from "../../utils/api";
import {PAYMENT_TYPE_TEACHER_HOUR} from "../../utils/constants";

export const generalActions = (props) => {
  return {
    setGeneralData: (data) => {
      props.dispatch({ type: SET_GENERAL_DATA, data })
    },
    isLoading: (data) => {
      props.dispatch({ type: IS_LOADING, data });
    },
    displayAlertDialog: (data) => {
        props.dispatch({ type: SHOW_ALERT_DIALOG,
            data
        });
    },
    displayAlertDialogWithMessage: (title, message) => {
          props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
              title: title,
              content: message
          });
      },
    // displayConfirmDialog: (data) => {
    //     props.dispatch({ type: SHOW_CONFIRM_DIALOG,
    //         data
    //     });
    // },
    displayConfirmDialog: (visibility, title, content, dateSelection, action) => {
          props.dispatch({ type: SET_CONFIRM_DIALOG_DATA,
              showConfirmDialog: visibility,
              title,
              content,
              dateSelection,
              confirmDialogAction : action
          });
    },
    toggleNavigationDrawer: (data) => {
      props.dispatch({ type: TOGGLE_NAV_DRAWER, data });
    },
    displayAppBar: (data) => {
      props.dispatch({ type: SHOW_APP_BAR, data });
    },
    getAllTeachers: (teacherName) => {
      const params = new URLSearchParams({
        name: teacherName ? teacherName: "",
      });
      api.qmsService
          .get(`/services/qms/teachers?${params.toString()}`)
          .then(res => {
            props.dispatch({ type: SET_GENERAL_DATA, data: {teachers: res.data} })
          })
          .catch(error => {
            // props.dispatch({ type: IS_LOADING, data: false });
            // props.dispatch({
            //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
            //     dialog: {
            //       dialogTitle: "Somthing went wrong!",
            //       dialogContent: error?.data?.error?.message
            //     },
            //     show: true
            //   }
            // });
          });
    },
      getAllTeachersSalary: (teacherName) => {
          const params = new URLSearchParams({
              name: teacherName ? teacherName: "",
          });
          api.qmsService
              .get(`/services/qms/teachers/salary?${params.toString()}`)
              .then(res => {
                  props.dispatch({ type: SET_GENERAL_DATA, data: {teachers: res.data} })
              })
              .catch(error => {
                  // props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
    getAllStudents: (studentName, programLvl) => {
      const params = new URLSearchParams({
          name: studentName ? studentName: "",
          programLvl: programLvl ? programLvl : ""
      });
      api.qmsService
          .get(`/services/qms/students?${params.toString()}`)
          .then(res => {
              props.dispatch({ type: SET_GENERAL_DATA, data: {students: res.data} })
          })
          .catch(error => {
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({
              //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
              //     dialog: {
              //       dialogTitle: "Somthing went wrong!",
              //       dialogContent: error?.data?.error?.message
              //     },
              //     show: true
              //   }
              // });
          });
    },
    getNewEnrolmentStudents: (studentName, programLvl, month) => {
          const params = new URLSearchParams({
              name: studentName ? studentName: "",
              programLvl: programLvl ? programLvl : "",
              month: month ? month : "",
          });
          api.qmsService
              .get(`/services/qms/students/enrollment?${params.toString()}`)
              .then(res => {
                  props.dispatch({ type: SET_GENERAL_DATA, data: {newEnrolmentStudents: res.data} })
              })
              .catch(error => {
                  // props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
    },
    getClassroom: (schedule, courseId, teacherName, programLvl, month, branch) => {
          const params = new URLSearchParams({
              schedule: schedule ? schedule: "",
              courseId: courseId ? courseId : "",
              teacherName: teacherName ? teacherName : "",
              programLvl: programLvl ? programLvl : "",
              enrolmentDate: month,
              branch: branch ? branch : ""
          });
          props.dispatch({ type: SET_GENERAL_DATA, data: {classroom: []} })
          api.qmsService
              .get(`/services/qms/classroom?${params.toString()}`)
              .then(res => {
                  props.dispatch({ type: SET_GENERAL_DATA, data: {classroom: res.data} })
              })
              .catch(error => {
                  // props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
    },
    getAllTuitionFees: () => {
      api.qmsService
          .get(`/services/qms/tuitionFees`)
          .then(res => {
            //TODO: Show dialog to update
              const data = res.data;
              for (let i=0; i < data.length; i ++) {
                  data[i].fee = data[i].fee/100;
              }
              props.dispatch({ type: SET_GENERAL_DATA, data: {tuitionFees: data} })

          })
          .catch(error => {

          });
    },
    getAllMisc: () => {
      api.qmsService
          .get(`/services/qms/misc`)
          .then(res => {
              const data = res.data;
              for (let i=0; i < data.length; i ++) {
                  data[i].fee = data[i].fee/100;
              }
              props.dispatch({ type: SET_GENERAL_DATA, data: {misc: data} })

          })
          .catch(error => {
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({
              //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
              //     dialog: {
              //       dialogTitle: "Somthing went wrong!",
              //       dialogContent: error?.data?.error?.message
              //     },
              //     show: true
              //   }
              // });
          });
    },

    getSingleStudentInfoByUuid: (history, uuid) => {
      api.qmsService
          .get(`/services/qms/student?uuid=${uuid}`)
          .then(res => {
              //TODO: Show dialog to update
              const data = res.data;
              for (let i=0; i < data.tuitionCourses.length; i ++) {
                  data.tuitionCourses[i].fee = data.tuitionCourses[i].fee/100;
              }

              for (let i=0; i < data.miscs.length; i ++) {
                  data.miscs[i].fee = data.miscs[i].fee/100;
              }
              props.dispatch({ type: SET_GENERAL_DATA, data: {student: data} })
              console.log(props);
              if (history){
                  history.push("/student/management/form")
              }
          })
          .catch(error => {
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({
              //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
              //     dialog: {
              //       dialogTitle: "Somthing went wrong!",
              //       dialogContent: error?.data?.error?.message
              //     },
              //     show: true
              //   }
              // });
          });
      },

      getSingleTeacherInfoByUuid: (history, uuid) => {
          api.qmsService
              .get(`/services/qms/teacher?uuid=${uuid}`)
              .then(res => {
                  //TODO: Show dialog to update
                  const data = res.data;
                  for (let i=0; i < data.tuitionCourses.length; i ++) {
                      data.tuitionCourses[i].fee = data.tuitionCourses[i].fee/100;
                  }
                  if (data.paymentType === PAYMENT_TYPE_TEACHER_HOUR){
                      data.paymentRate = data.paymentRate/100;
                  }
                  props.dispatch({ type: SET_GENERAL_DATA, data: {teacher: data} })
                  history.push("/teacher/management/form")

              })
              .catch(error => {
                  // props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      getAnnouncements: () => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/announcements`)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: GET_ANNOUNCEMENTS, data: {announcements: res.data} })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Something went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      createAnnouncement: (authorName, content, programLvl, subjectId, classSession) => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {
              authorName,
              content,
              programLvl,
              subjectId,
              classSession
          }
          api.qmsService
              .post(`/services/qms/announcements/create`, payload)
              .then(res => {
                  props.dispatch({ type: GET_ANNOUNCEMENTS, data: {announcements: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      updateAnnouncement: (id, authorName, content, programLvl, subjectId, classSession) => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {
              id,
              authorName,
              content,
              programLvl,
              subjectId,
              classSession
          }
          api.qmsService
              .post(`/services/qms/announcements/update`, payload)
              .then(res => {
                  props.dispatch({ type: GET_ANNOUNCEMENTS, data: {announcements: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      getQuiz: () => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/quiz`)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: GET_QUIZ, data: {quiz: res.data} })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Something went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      createQuiz: (teacherId, courseId, programLvl, title, url) => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {
              teacherId,
              courseId,
              programLvl,
              title,
              url
          }
          api.qmsService
              .post(`/services/qms/quiz`, payload)
              .then(res => {
                  props.dispatch({ type: GET_QUIZ, data: {quiz: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      updateQuiz: (quizId, teacherId, courseId, programLvl, title, url, status="ACTIVE") => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {
              quizId,
              teacherId,
              courseId,
              programLvl,
              title,
              url,
              status
          }
          api.qmsService
              .put(`/services/qms/quiz`, payload)
              .then(res => {
                  props.dispatch({ type: GET_QUIZ, data: {quiz: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      getNotes: () => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/note`)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: GET_NOTE, data: {notes: res.data} })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Something went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      createNote: (teacherId, courseId, programLvl, title, url) => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {
              teacherId,
              courseId,
              programLvl,
              title,
              url
          }
          api.qmsService
              .post(`/services/qms/note`, payload)
              .then(res => {
                  props.dispatch({ type: GET_NOTE, data: {notes: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      updateNote: (noteId, teacherId, courseId, programLvl, title, url, status="ACTIVE") => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {
              noteId,
              teacherId,
              courseId,
              programLvl,
              title,
              url,
              status
          }
          api.qmsService
              .put(`/services/qms/note`, payload)
              .then(res => {
                  props.dispatch({ type: GET_NOTE, data: {notes: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      updateTimetable: (timetableId, startTime, endTime, dayOfWeek, subjectId, programLvl, classroom, classSession, status="ACTIVE") => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {id: timetableId, startTime, endTime, dayOfWeek, subjectId, programLvl, classroom, classSession, status};
          api.qmsService
              .put(`/services/qms/student/timetables`, payload)
              .then(res => {
                  props.dispatch({ type: GET_TIMETABLE, data: {timetables: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      createTimetable: (startTime, endTime, dayOfWeek, subjectId, programLvl, classroom, classSession) => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = {startTime, endTime, dayOfWeek, subjectId, programLvl, classroom, classSession};
          api.qmsService
              .post(`/services/qms/student/timetables`, payload)
              .then(res => {
                  props.dispatch({ type: GET_TIMETABLE, data: {timetables: res.data} })
                  props.dispatch({ type: IS_LOADING, data: false });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      getTimetables: () => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/student/timetables`)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: GET_TIMETABLE, data: {timetables: res.data} })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Something went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
      getAllBanks: () => {
          api.qmsService
              .get(`/services/qms/banks`)
              .then(res => {
                  const data = res.data;
                  for (let i=0; i < data.length; i ++) {
                      data[i].fee = data[i].fee/100;
                  }
                  props.dispatch({ type: SET_BANK_LIST, data: res.data })

              })
              .catch(error => {
                  // props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
      },
  }


}


